import { create } from '@bufbuild/protobuf'
import {
  DateSchema,
  type Date as ProtoDate,
} from '@ebalance/proto/google/type/date_pb'

/**
 * 詳細の「計画を作り直す」 (AC-PLC-020-2) で計画を作成した後、一覧へ渡す location state。
 * 一覧は作成した計画の対象日に対象日フィルタを合わせる (AC-PLC-054。判定は一覧側)。
 */
export type CreatedPlanNavigationState = {
  createdPlanTargetDate: { year: number; month: number; day: number }
}

export function createdPlanNavigationState(
  targetPeriodStartDate: ProtoDate,
): CreatedPlanNavigationState {
  const { year, month, day } = targetPeriodStartDate
  return { createdPlanTargetDate: { year, month, day } }
}

/** location state から作成した計画の対象日を読む。形が違えば undefined (履歴の state は型を信用しない)。 */
export function readCreatedPlanTargetDate(
  state: unknown,
): ProtoDate | undefined {
  if (typeof state !== 'object' || state === null) return undefined
  const date = (state as Partial<CreatedPlanNavigationState>)
    .createdPlanTargetDate
  if (
    typeof date?.year !== 'number' ||
    typeof date.month !== 'number' ||
    typeof date.day !== 'number'
  ) {
    return undefined
  }
  return create(DateSchema, date)
}
